import React from "react";
import styled, { keyframes } from "styled-components/macro";

const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position:  400px 0; }
`;

const SkeletonBar = styled.div`
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e4e4e4 50%, #f0f0f0 75%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s infinite;
  height: ${({ height }) => height || "13px"};
  width: ${({ width }) => width || "100%"};
  margin-bottom: ${({ mb }) => mb || "8px"};
`;

const SkeletonCircle = styled(SkeletonBar)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-bottom: 0;
`;

const Card = styled.div`
  background: white;
  border-radius: 1em;
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  padding: ${({ theme }) => theme.spacing.md};
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

export default function PanelSkeleton() {
  return (
    <>
      {/* Coach card skeleton */}
      <Card>
        <Row>
          <SkeletonCircle />
          <div style={{ flex: 1 }}>
            <SkeletonBar width="55%" mb="8px" />
            <SkeletonBar width="40%" />
          </div>
        </Row>
        <SkeletonBar mb="6px" />
        <SkeletonBar width="80%" mb="16px" />
        <SkeletonBar height="58px" mb="10px" />
        <SkeletonBar height="40px" />
      </Card>

      {/* Next step skeleton */}
      <Card>
        <SkeletonBar height="16px" width="50%" mb="10px" />
        <SkeletonBar height="70px" />
      </Card>

      {/* Events skeleton */}
      <Card>
        <SkeletonBar height="16px" width="60%" mb="10px" />
        <Row style={{ marginBottom: 0 }}>
          <SkeletonCircle style={{ borderRadius: "0.75em" }} />
          <div style={{ flex: 1 }}>
            <SkeletonBar width="70%" mb="6px" />
            <SkeletonBar width="50%" />
          </div>
        </Row>
      </Card>
    </>
  );
}
